import React from "react";
import Navigation from "./Navigation";
import Home from "./Home";
import About1 from "./About1";
import Products from "./Product1";
import AnnouncementBar from "./AnnouncementBar";
import Footer from './Footer';
import Services from './Services'
// import Blog from './Blog'
import FireSafety from './FireSafetySection'
import Slider from "./Slider"



const Main = () => {
  return (
    <div className="relative">


      {/* Navigation - Sticky */}
      <div className="sticky top-0 z-50">
        <Navigation />
      </div>

      {/* Home Section - Full Screen */}
      <div className="min-h-screen w-full">
        <Home />
      </div>

      {/* Announcement Bar */}
      <div className=" w-full mt-[40px]">
        <AnnouncementBar />
      </div>

      {/* About Section */}
      <div className=" w-full">
        <About1 />
      </div>
      {/* Services Section */}
      <div className=" w-full">
        <Services />
      </div>

      {/* Products Section */}
      <div className=" w-full">
        <Products />
      </div>

      {/* Fire Safety Section */}
      <div className=" w-full">
        <FireSafety />
      </div>

      {/* Blog Section */}
      {/* <div className=" w-full">
        <Blog />
      </div> */}

      {/* Footer Section */}
      <div className=" w-full mt-8">
        <Footer />
      </div>
    </div>
  );
};

export default Main;
